"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfHundredthsOfMillimeterConverter = exports.RtfPixelsToTwipsConverter = exports.RtfPictureUnitsConverter = void 0;
var tslib_1 = require("tslib");
var unit_converter_1 = require("@devexpress/utils/lib/class/unit-converter");
var RtfPictureUnitsConverter = (function () {
    function RtfPictureUnitsConverter() {
    }
    return RtfPictureUnitsConverter;
}());
exports.RtfPictureUnitsConverter = RtfPictureUnitsConverter;
var RtfPixelsToTwipsConverter = (function (_super) {
    tslib_1.__extends(RtfPixelsToTwipsConverter, _super);
    function RtfPixelsToTwipsConverter(dpi) {
        var _this = _super.call(this) || this;
        _this.dpi = dpi;
        return _this;
    }
    RtfPixelsToTwipsConverter.prototype.unitsToTwips = function (val) {
        return Math.round(1440 * val / this.dpi);
    };
    RtfPixelsToTwipsConverter.prototype.unitsToModelUnits = function (val) {
        return unit_converter_1.UnitConverter.pixelsToTwipsCustomDpi(val, this.dpi);
    };
    return RtfPixelsToTwipsConverter;
}(RtfPictureUnitsConverter));
exports.RtfPixelsToTwipsConverter = RtfPixelsToTwipsConverter;
var RtfHundredthsOfMillimeterConverter = (function (_super) {
    tslib_1.__extends(RtfHundredthsOfMillimeterConverter, _super);
    function RtfHundredthsOfMillimeterConverter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RtfHundredthsOfMillimeterConverter.prototype.unitsToTwips = function (val) {
        return Math.round(1440 * val / 2540.0);
    };
    RtfHundredthsOfMillimeterConverter.prototype.unitsToModelUnits = function (val) {
        return unit_converter_1.UnitConverter.hundredthsOfMillimeterToTwipsRound(val);
    };
    return RtfHundredthsOfMillimeterConverter;
}(RtfPictureUnitsConverter));
exports.RtfHundredthsOfMillimeterConverter = RtfHundredthsOfMillimeterConverter;
